import actions from '../../actionTypes';

export default () => {
  return {
    type: actions.READ_TOKEN
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/readToken.js